import classNames from 'classnames/bind';
import { IFlightSearchHistory } from 'hooks/useHistory';
import { useState } from 'react';
import styles from '../index.module.scss';
import Item from '../item';

const cx = classNames.bind(styles);
const PREVIEW_COUNT = 3;

interface IProps {
  count: number;
  searchHistories: IFlightSearchHistory[];
  deleteHistoryFunc: (historyId: string) => Promise<any>;
}

function Mobile({ count, searchHistories, deleteHistoryFunc }: IProps) {
  const [isMore, toggleMore] = useState(false);

  return (
    <>
      <ul className={cx('list_mo')}>
        {searchHistories
          .slice(0, isMore ? count : PREVIEW_COUNT)
          .map(history => (
            <Item
              key={history.historyId}
              history={history}
              deleteHistory={deleteHistoryFunc}
            />
          ))}
      </ul>
      {searchHistories.length > PREVIEW_COUNT && isMore === false && (
        <button
          type="button"
          className={cx('more')}
          aria-expanded={isMore}
          data-event-nlog="click"
          data-event-area-code="mai.recentmore"
          onClick={() => toggleMore(prev => !prev)}
        >
          펼쳐보기
        </button>
      )}
    </>
  );
}

export default Mobile;
